import { ValidationErrorComponent } from 'components/common-form/sidePanel/status/validationErrors/ValidationErrors.status';

import { connectValidationErrors } from './ValidationErrors.connect';

export const ValidationErrors = connectValidationErrors(ValidationErrorComponent);
